//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <p style="font-size:16px;">Пользователи сайта</p>
    <div v-if="((commonData.isLoaded == true) && (users.length != 0))">
      <entity-manager :data="users" :options="usersEntityManagerOptions" style="padding-top: 20px;">
        <template slot="dataItemFieldTableView" scope="viewProps">
          <span v-if="viewProps.column.field == 'updatedAt'">
            {{viewProps.dataRow.val[viewProps.column.field] | formatDate}}
          </span>
          <span v-else-if="viewProps.column.field == 'GroupID'">
            <span v-if="(viewProps.dataRow.val[viewProps.column.field] != -1) && (viewProps.dataRow.val['Deleted'] != -1)">
              {{commonData.usersGroups[viewProps.dataRow.val[viewProps.column.field]].Name}}
            </span>
          </span>
          <span v-else-if="viewProps.column.field == 'deleted'">
            <span v-if="viewProps.dataRow.val['deleted'] == true">Удален</span>
            <span v-else>Нет</span>
          </span>
          <span v-else>
            {{viewProps.dataRow.val[viewProps.column.field]}}
        </span>
        </template>

        <template slot="dataItemFieldEditView" scope="viewProps">
          <span v-if="viewProps.fieldKey == 'id'">
            {{viewProps.editingDataRow.val[viewProps.fieldKey]}}
          </span>
          <span v-else-if="viewProps.fieldKey == 'deleted'">
            <select v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" filterable placeholder="Выберите значение" style="width:100%; height: 32px; background-color:#fff"
            @change="viewProps.editingDataRow.val[viewProps.fieldKey] == 'true' ? viewProps.editingDataRow.val[viewProps.fieldKey] = true : viewProps.editingDataRow.val[viewProps.fieldKey] = false">
              <option value=true>Удален</option>
              <option value=false>Нет</option>
            </select>
          </span>
          <span v-else-if="viewProps.fieldKey == 'GroupID'">
            <Select
             v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" filterable placeholder="Выберите группу">
              <Option v-if="item != null" v-for="item in commonData.usersGroups" :value="item.id" :key="item.id">{{item.Name}}</Option>
            </Select>
          </span>
          <span v-else>
            <Input v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" style="width:100%"></Input>
          </span>
        </template>
      </entity-manager>
    </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import EntityManager from '@/technical/components/EntityManager'

export default {
  data () {
    return {
      users: [],
      // usersGroups: this.commonData.usersGroups,
      usersEntityManagerOptions: {
        tableColumns: [
          {title: 'id', width: '40px', field: 'id'},
          {title: 'Имя', width: '', field: 'name'},
          {title: 'Логин', width: '150px', field: 'login'},
          {title: 'Email', width: '180px', field: 'email'},
          {title: 'Удален', width: '70px', field: 'deleted'}
        ],
        editorFields: {name: 'Имя', login: 'Логин', email: 'Email', password: 'Пароль', deleted: 'Удален', id: 'id'},
        newEmptyEntity: function (thisRef) {
          let result = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsUserSiteResource)
          result.val = {}
          result.val.name = ''
          result.val.login = ''
          result.val.email = ''
          result.val.password = ''
          result.val.deleted = false
          return result
        },
        commonDataReloadOptions: {users: true},
        disableDelete: true
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'commonData'
    ])
  },
  components: { EntityManager },
  created: function () {
    var thisRef = this

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! это надо выносить в общий компонент читки статических данных с сервера и занесение их в store.CommonData
    var users = []
    var userResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsUserSiteResource)
    userResource.query()
    .then(function (response) {
      if (response.data == null) return serverErrorHandling('что-то не так', thisRef)
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        var oneUserResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsUserSiteResource)
        oneUserResource.val = response.data[itemIndx]
        users.push(oneUserResource)
      }
      thisRef.users = users
    })
    .catch((error) => serverErrorHandling(error, thisRef))
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// UsersSite.vue?668a5bd0